import ArticleLayout from "@/components/feature/ArticleLayout";
import { articles } from "@/mocks/articles";

const article = articles[3];

export default function Artigo() {
  return (
    <ArticleLayout
      title={article.title}
      description={article.excerpt}
      date={article.date}
      readTime={article.readTime}
      imageUrl={article.imageUrl}
      keywords="Jordan CSSBuy, Air Jordan CSSBuy, links Jordan, Jordan spreadsheet, comprar Jordan China"
      articleSchemaName="CSSBuy Spreadsheet"
    >
      <p>
        Os Air Jordan são dos ténis mais icónicos de sempre e, naturalmente, dos mais procurados na nossa <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow">CSSBuy Spreadsheet</a>. Se és fã da linha Jordan, este artigo é para ti.
      </p>

      <h2>Modelos Jordan Mais Populares no CSSBuy</h2>
      <p>
        Na planilha, encontras links para praticamente todos os modelos Jordan:
      </p>
      <ul>
        <li><strong>Air Jordan 1</strong>: High, Low, Mid, Travis Scott, Off-White</li>
        <li><strong>Air Jordan 3</strong>: Black Cement, White Cement, colaborações</li>
        <li><strong>Air Jordan 4</strong>: Military Black, Bred, colaborações</li>
        <li><strong>Air Jordan 11</strong>: Space Jam, Concord, Bred</li>
        <li><strong>Air Jordan 6</strong>: Infrared, Travis Scott</li>
      </ul>

      <h2>Qualidade dos Jordan no CSSBuy</h2>
      <p>
        A qualidade varia conforme o vendedor e o batch (lote de produção). Os batches mais conhecidos incluem LJR, OG, PK e FK — cada um com as suas vantagens. O batch LJR, por exemplo, é considerado o melhor para Jordan 1. Na nossa planilha, indicamos o batch recomendado para cada modelo.
      </p>

      <h2>Como Escolher o Melhor Jordan</h2>
      <p>
        Antes de comprar, recomendamos:
      </p>
      <ul>
        <li>Pesquisar reviews do modelo específico no Reddit (r/cssbuy, r/repweidiansneakers)</li>
        <li>Comparar as fotos de QC com fotos de retail (legítimas)</li>
        <li>Verificar a tabela de tamanhos — Jordan costuma ser TTS (true to size)</li>
        <li>Usar os links verificados da <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow">nossa planilha</a></li>
      </ul>

      <h2>Preços de Referência</h2>
      <p>
        Um Air Jordan 1 de alta qualidade no CSSBuy custa entre €40 e €65, dependendo do batch. Jordan 4 de qualidade ronda os €45-70. Estes valores são uma fração do preço de revenda no mercado europeu, onde estes modelos frequentemente ultrapassam os €300.
      </p>
    </ArticleLayout>
  );
}